import { render, staticRenderFns } from "./OrderMenuParameters.vue?vue&type=template&id=1f56c0d8&scoped=true"
import script from "./OrderMenuParameters.vue?vue&type=script&lang=js"
export * from "./OrderMenuParameters.vue?vue&type=script&lang=js"
import style0 from "./OrderMenuParameters.vue?vue&type=style&index=0&id=1f56c0d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f56c0d8",
  null
  
)

export default component.exports